module.exports = __webpack_public_path__ + "resources/img/img_sqml_di2_jp.18e1370611596856fa8a4979f1aa452b.png";